// extracted by mini-css-extract-plugin
export default {"tableBody":"PhaseEditor-module__tableBody___szK3V","phaseName":"PhaseEditor-module__phaseName___e5VsH","totalsWrapper":"PhaseEditor-module__totalsWrapper___aOi63"};